module.exports = __webpack_public_path__ + "media/images/icons/house_rules/smoking-d3c9dc3274d6c292a2b4cf9fd9876482.svg";